import React, { PropsWithChildren } from 'react';
import { FilterPanelProvider } from './components/FilterPanelProvider/FilterPanelProvider';
import Filters from './components/Filters/Filters';
import PrimaryButtonsLine from './components/PrimaryButtonsLine/PrimaryButtonsLine';
import SavedFilters from './components/SavedFilters/SavedFilters';
import style from './FilterPanel.module.scss';
import { FilterPanelProps } from './types';

const FilterPanelBase: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return <div className={style.filtersContainer}>{children}</div>;
};

const FilterPanel: React.FC<PropsWithChildren<FilterPanelProps>> & {
  PrimaryButtons: typeof PrimaryButtonsLine;
  Filters: typeof Filters;
  SavedFilters: typeof SavedFilters;
} = (props) => {
  return (
    <FilterPanelProvider {...props}>
      <FilterPanelBase>{props.children}</FilterPanelBase>
    </FilterPanelProvider>
  );
};

FilterPanel.PrimaryButtons = PrimaryButtonsLine;
FilterPanel.Filters = Filters;
FilterPanel.SavedFilters = SavedFilters;

export default FilterPanel;
